<template>
  <weui-group type="radio" :notitle="notitle" :title="title" :tips="tips">
    <weui-radiobox
      :name="group"
      v-for="opt in options2"
      v-bind="opt"
      :key="opt.value"
      @change="fireChange(opt.value)"
    />
  </weui-group>
</template>

<script>
import mixinUniqid from '@/mixins/uniqid';

import WeuiGroup from '../group/Index';
import WeuiRadiobox from './RadioBox';

export default {
    props: {
        notitle: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: null,
        },
        tips: {
            type: String,
            default: null,
        },
        options: {
            type: Array,
            required: true,
        },
        value: {
            type: [String, Number, Boolean],
            required: true,
        },
    },
    data() {
        return {
            group: this.uniqid(),
        };
    },
    computed: {
        options2() {
            return this.options
                .map(o => ({
                    ...o,
                    checked: o.value === this.value,
                }));
        },
    },
    methods: {
        fireChange(val) {
            this.$emit('input', val);
        },
    },
    mixins: [
        mixinUniqid,
    ],
    components: {
        WeuiGroup,
        WeuiRadiobox,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/weui/radio-group/Index.vue